import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const purificationApi = createApi({
    reducerPath: "core/purification",
    baseQuery: axiosBaseQuery,
    tagTypes: ["purificationList"],
    endpoints: (builder) => ({
        purificationFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['purificationList'],
            query: (query = '') => ({
                url: "/core/purification" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        purificationCreate: builder.mutation({
            invalidatesTags: ['purificationList'],
            query: (data) => ({
                url: `/core/purification`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        purificationUpdate: builder.mutation({
            invalidatesTags: ['purificationList'],
            // query: (data)=>({url: "/core/purification/"+data.id, method: "PUT", data})
            query: (data) => ({
                url: `/core/purification/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        purificationDelete: builder.mutation({
            invalidatesTags: ['purificationList'],
            query: (id) => ({ url: "/core/purification/" + id, method: "DELETE" })
        }),
    })
})

export const { usePurificationFindAllQuery, usePurificationCreateMutation, usePurificationUpdateMutation, usePurificationDeleteMutation } = purificationApi;
export { purificationApi };
